import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from 'projects/cross-study-portal-lib/src/public-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(private httpClient: HttpClient,
    private apiUrl: ApiUrlService) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logout(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl.get()}/logout`);
  }
}
